import React, {useState, Fragment, useEffect, useRef} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import {getAnexosEquipamento, getAnexo} from '../../../../pages/requests';
import NotFound from '../../../NotFound';
import {useTranslation} from 'react-i18next';

// import { Container } from './styles';

function PdfGroupModalEquipamentos({back, dataPdf, setDataPdf, idEquipamento, loadingPdf, setLoadingPdf, setIdDocumento}) {
    const cancelButtonRef = useRef(null);
    const [anexos, setAnexos] = useState([]);
    const {t} = useTranslation();

    useEffect(() => {
        if (idEquipamento) {
            getAnexosEquipamento(idEquipamento).then(function (response) {
                if (response.data.success) {
                    setAnexos(response.data.anexos);
                }
            });
        }
    }, [idEquipamento]);

    function handleGetPdf(dados) {
        setLoadingPdf(true);
        let abrev = dados.abrev;
        let ident1 = dados.ident1;
        let ident2 = dados.ident2;
        let ident3 = dados.ident3;
        getAnexo(abrev, ident1, ident2, ident3)
            .then(function (response) {
                if (response.data.success) {
                    setDataPdf(response.data.anexos.blob);
                }
            })
            .finally(() => {
                setLoadingPdf(false);
            });
    }

    useEffect(() => {
        if (idEquipamento) {
            getAnexosEquipamento(idEquipamento).then(function (response) {
                if (response.data.success) {
                    setAnexos(response.data.anexos);
                }
            });
        }
    }, [idEquipamento]);

    return (
        <Transition.Root show as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={() => back()}>
                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-[8px] text-gray-500 px-1 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            back();
                                            //   setShowForm(false);
                                            //   setOpen(false);
                                        }}>
                                        <CloseIcon />
                                    </button>
                                </div>
                                <div className="flex flex-col bg-white py-3 ">
                                    {anexos.map(dados => (
                                        <div
                                            className="flex flex-row items-center px-4 hover:bg-slate-200 w-full cursor-pointer"
                                            onClick={() => {
                                                setIdDocumento('');
                                                handleGetPdf(dados);
                                            }}>
                                            <PictureAsPdfRoundedIcon className="w-32 mr-2  text-blue-500" />

                                            <p className="text-base leading-relaxed text-gray-600 ">{dados.nome}</p>
                                        </div>
                                    ))}
                                </div>
                                {anexos.length == 0 && (
                                    <div className="flex flex-row justify-center py-6 font-semibold text-lg -mt-3">
                                        {' '}
                                        <p>{t('semRegistos')}</p>
                                    </div>
                                )}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default PdfGroupModalEquipamentos;
